import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './TransactionService.scss'
import { TransactionServiceAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import SupportCenterBox from '../../../common/components/SupportCenterBox'
import { useParams } from 'react-router-dom'

const SupportCenterContainer1 = styled.div`
  padding-top: 120px !important;
  padding-left: 120px !important;
  padding-right: 120px !important;
  padding-bottom: 50px !important;
  background: rgb(248, 248, 248);

  @media screen and (max-width: 767px) {
    padding: 24px 30px !important;
  }
`

const SupportCenterContainer2 = styled.div`
  padding-left: 120px !important;
  padding-right: 120px !important;
  padding-bottom: 50px !important;
  background: rgb(248, 248, 248);

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px !important;
  }
`

const Title1 = styled.h1`
  padding-bottom: 30px;
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  color: rgb(94, 81, 77);
`
const Title2 = styled.h1`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 22px;
  line-height: 48px;
  color: rgb(94, 81, 77);
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const SupportCenter = function () {
  const { t } = useTranslation()
  const [dataTeller, setdataTeller] = useState([])
  const [dataCustomer, setdataCustomer] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    setisLoading(true)
    loadData()
  }, [])

  const loadData = async function () {
    const { data } = await TransactionServiceAPI()
    if (data?.data) {
      setdataTeller(data.data.teller)
      setdataCustomer(data.data.customer)
    }

    setisLoading(false)
  }

  return (
    <div>
      <SupportCenterContainer1 className="container-fluid">
        <Title1>{t('layanan_transaksi')}</Title1>
        <div className="row">
          <Title2>{t('layanan_teller')}</Title2>
          {dataTeller
            .sort((a, b) => {
              return a.gridPosition - b.gridPosition
            })
            .map((item) => (
              <div className="col-lg-4 mt-4">
                <Link
                  target="_blank"
                  to={{ pathname: item.url }}
                  style={{ textDecoration: 'none' }}
                >
                  <Desktop>
                    <SupportCenterBox
                      info={item.judul}
                      image={item.imageIconDesktop}
                    />
                  </Desktop>
                  <Mobile>
                    <SupportCenterBox
                      // title={item.judul}
                      info={item.judul}
                      image={item.imageIconMobile}
                    />
                  </Mobile>
                </Link>
              </div>
            ))}
        </div>
      </SupportCenterContainer1>

      <SupportCenterContainer2 className="container-fluid">
        <Title2>{t('layanan_customer')}</Title2>
        <div className="row">
          {dataCustomer.map((item) => (
            <div className="col-lg-4 mt-4">
              <Link
                target="_blank"
                to={{ pathname: item.url }}
                style={{ textDecoration: 'none' }}
              >
                <Desktop>
                  <SupportCenterBox
                    info={item.judul}
                    image={item.imageIconDesktop}
                  />
                </Desktop>
                <Mobile>
                  <SupportCenterBox
                    info={item.judul}
                    image={item.imageIconMobile}
                  />
                </Mobile>
              </Link>
            </div>
          ))}
        </div>
      </SupportCenterContainer2>

      <FooterSection currentPage={t('layanan_pengaduan')} />
    </div>
  )
}

export default SupportCenter
